export default __webpack_public_path__ + "static/woori_bank-af5e6f2d21d8f7747f3b740b46c18cc2.png";